import React from "react";
import styled from "styled-components";
import { orangish } from "../constants/styles";

const UnnamedComponent = (props) => {
  const relOverride = React.useMemo(() => {
    let isInternal = false;
    try {
      const host = new URL(props.to).hostname;
      isInternal = host.endsWith(".taxsam.co");
    } catch {
      isInternal = true;
    }
    if (isInternal) return { rel: "noopener" };
  }, [props.to]);

  return (
    <SLink
      className={props.className}
      href={props.to}
      target="_blank"
      rel="noopener noreferrer"
      {...relOverride}
      children={props.children}
      onClick={props.onClick}
      tabIndex={props.tabIndex}
    />
  );
};
export default UnnamedComponent;

const SLink = styled.a`
  transition: color 0.2s ease;

  &:hover,
  &:active,
  &:focus {
    color: ${orangish};
  }
`;
